import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment-alt-solid",
  "use": "icon-comment-alt-solid-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-comment-alt fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-comment-alt-solid\"><path fill=\"currentColor\" d=\"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol